import { parseQuery } from '@libs/utils';
import type { QueryString } from '@libs/utils';

import { cookie } from './cookie';

export interface AffiliateCookieData {
  AffiliateId?: string;
  ClientId?: string;
}

enum AffilliateCookieProperties {
  AffiliateId = 'AffiliateId',
  ClientId = 'ClientId',
}

enum Cookies {
  AffiliateCookie = 'AffiliateCookie',
}

export function getAffiliateCookieData():
  | {
      affiliateCookie: string;
      affiliateCookieParams: AffiliateCookieData;
    }
  | undefined {
  const affiliateCookie = cookie.get(Cookies.AffiliateCookie);
  const affiliateCookieData: AffiliateCookieData = {};

  if (!affiliateCookie) {
    return;
  }

  const affiliateCookieParams = getCookieParams(
    affiliateCookie,
    AffilliateCookieProperties.AffiliateId,
    AffilliateCookieProperties.ClientId
  );
  affiliateCookieData.AffiliateId = affiliateCookieParams['AffiliateId'];
  affiliateCookieData.ClientId = affiliateCookieParams['ClientId'];

  return {
    affiliateCookie,
    affiliateCookieParams,
  };
}

export function getCookieParams(
  cookie: string,
  ...cookieParams: string[]
): Record<string, string | undefined> {
  const parsedCookie: QueryString = parseQuery(cookie);

  return cookieParams.reduce((cokieDictionary, param) => {
    cokieDictionary[param] = getParsedCookieParam(param, parsedCookie);
    return cokieDictionary;
  }, {} as Record<string, string | undefined>);
}

function getParsedCookieParam(
  cookieValue: string,
  parsedCookie: QueryString
): string | undefined {
  const cookieProperty = parsedCookie[cookieValue];
  if (cookieProperty) {
    return cookieProperty[0];
  }
}
